<template>
  <div class="textarea" ref="textarea">
    <div class="text-main">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    scroll() {
      this.$refs.textarea.scrollTop = 0;
    }
  }
};
</script>


<style lang="scss">
@import "../assets/base";
.textarea {
  height: 60vh;
  overflow-y: auto;
  -webkit-transform: translateZ(0px);

  @include default-scrollbar;

  .text-main {
    padding-left: 1rem;
    padding-right: 1rem;
    line-height: 1.6;

    p {
      word-wrap: break-word;
    }
  }
}
</style>
